/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_SubtitleInputs */



/**
* | output |
* | --- |
* | "Partner invoicing for the selected month. Amounts are net." |
*
* @param {Partner_Billing_Board_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_subtitle = /** @type {((inputs?: Partner_Billing_Board_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Partnerabrechnung für den gewählten Monat. Beträge sind netto.")
	return /** @type {LocalizedString} */ ("Partner invoicing for the selected month. Amounts are net.")
});